export enum FuelType {
  NoSelection = 'noselection',
  Petrol = 'petrol',
  Diesel = 'diesel',
  Electric = 'electric',
  Other = 'other',
}
